import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  GraphqlRequestType,
  ItemNotFound,
} from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { ServiceCategoryModel } from '@app/src/app/modules/service/classes/category/model/service.category.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class ServiceCategoryByRequestQuery extends AbstractGraphqlRequest<
  ServiceCategoryModel | ItemNotFound
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findOneServiceCategoryBy(
        $payload: ServiceCategoryRequestPayloadInput
      ) {
        findOneServiceCategoryBy(payload: $payload) {
          cover {
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          slug
          title
          description
          shortDescription
          data {
            leftColor
            rightColor
          }
          active
          createdAt
          updatedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let item = data.findOneServiceCategoryBy;

    if (item) {
      return new ServiceCategoryModel(item);
    }

    return new ItemNotFound();
  }
}
